module.exports = __webpack_public_path__ + "img/from-to-arrows-small-icon.90b4164e.svg";